import React, { useReducer } from 'react';
import LegalesReducer from './legalesReducer';
import legalesContext from './legalesContext';
import clienteAxios from "../../service/axios";

import { 
    OBTENER_TERMINOS_Y_CONDICIONES,
    OBTENER_POLITICAS_DE_PRIVACIDAD,
    OBTENER_TERMINOS_ACEPTADOS,
    OBTENER_POLITICAS_ACEPTADAS,
    OBTENER_TERMINOS_Y_CONDICIONES_HISTORICO,
    ACEPTAR_TERMINOS_Y_CONDICIONES,
    ACEPTAR_POLITICAS_DE_PRIVACIDAD,
    PROGRESS
} from 'types/context';

const LegalesState = props => {
    const initialState = {
        terminosYCondiciones: null,
        progress: 0,
        politicasDePrivacidad: null,
        terminosAceptados: null,
        politicasAceptadas: null
    }

    const [state, dispatch] = useReducer(LegalesReducer, initialState);

    const host = process.env.REACT_APP_BACKEND_URL || 'https://app.dev.pampa4.ar:4000/'

    const obtenerTerminosYCondiciones = async () => {
        try {
            // siempre deberia venir un cliente
            
            const resultado = await clienteAxios.get(`/terminos-y-condiciones?actual=true`);
            //
            let terminosYCondiciones 

            if ( resultado?.data?.terminosYCondiciones != null ) {
                terminosYCondiciones = {}
                terminosYCondiciones = resultado.data.terminosYCondiciones 
                terminosYCondiciones.pdf = host + terminosYCondiciones.file?.path
            }

            dispatch({
                type: OBTENER_TERMINOS_Y_CONDICIONES,
                payload: terminosYCondiciones
            });

            return terminosYCondiciones
        } catch (error) {
            
            const alerta = {
                msg: error,
                categoria: 'error'
            }
            return alerta
        }
    }
    const obtenerTerminosYCondicionesHistorico = async () => {
        try {
            const terminos = []
            const resultado = await clienteAxios.get(`/terminos-y-condiciones`);

            if ( resultado?.data?.terminosYCondiciones?.rows ) {
                resultado.data.terminosYCondiciones.rows.map(termino => {
                    terminos.push({
                        ...termino,
                        pdf: host + termino.file?.path
                    })
                })
            }

            return terminos
        } catch (error) {
            
            const alerta = {
                msg: error,
                categoria: 'error'
            }
            return alerta
        }
    }

    const obtenerTerminosAceptados = async (usuarioId) => {
        try {
            // siempre deberia venir un cliente
            
            const resultado = await clienteAxios.get(`/terminos-y-condiciones/${usuarioId}`);
            //
            dispatch({
                type: OBTENER_TERMINOS_ACEPTADOS,
                payload: !!resultado.data.terminosYCondicionesAceptados
            });
            return !!resultado.data.terminosYCondicionesAceptados
        } catch (error) {
            
            const alerta = {
                msg: error,
                categoria: 'error'
            }
            return alerta
        }
    }

    const obtenerPoliticasDePrivacidad = async () => {
        try {
            // siempre deberia venir un cliente
            
            const resultado = await clienteAxios.get(`/politicas-de-privacidad?actual=true`);

            let politicasDePrivacidad 

            if ( resultado?.data?.politicasDePrivacidad != null ) {
                politicasDePrivacidad = {}
                politicasDePrivacidad = resultado.data.politicasDePrivacidad 
                politicasDePrivacidad.pdf = host + politicasDePrivacidad.file?.path
            } 
            
            dispatch({
                type: OBTENER_POLITICAS_DE_PRIVACIDAD,
                payload: politicasDePrivacidad
            });

            return politicasDePrivacidad
        } catch (error) {
            
            const alerta = {
                msg: error,
                categoria: 'error'
            }
            return alerta
        }
    }

    const obtenerPoliticasAceptadas = async (usuarioId) => {
        try {
            // siempre deberia venir un cliente
            
            const resultado = await clienteAxios.get(`/politicas-de-privacidad/${usuarioId}`);
            //
            dispatch({
                type: OBTENER_POLITICAS_ACEPTADAS,
                payload: !!resultado.data.politicasDePrivacidadAceptadas
            });
            return !!resultado.data.politicasDePrivacidadAceptadas
        } catch (error) {
            
            const alerta = {
                msg: error,
                categoria: 'error'
            }
            return alerta
        }
    }
    const obtenerPoliticasDePrivacidadHistorico = async () => {
        try {
            const politicas = []
            const resultado = await clienteAxios.get(`/politicas-de-privacidad`);
            if ( resultado?.data?.politicasDePrivacidad?.rows ) {
                resultado.data.politicasDePrivacidad.rows.map(politica => {
                    politicas.push({
                        ...politica,
                        pdf: host + politica.file?.path
                    })
                })
            }

            return politicas
        } catch (error) {
            
            const alerta = {
                msg: error,
                categoria: 'error'
            }
            return alerta
        }
    }
    const aceptarPoliticas = async ( politicasId ) => {
        try {
            // siempre deberia venir un cliente            
            const resultado = await clienteAxios.post(`/politicas-de-privacidad/aceptar`,
            { politicasDePrivacidadId: politicasId }
            );

            return !!resultado.data.politicasDePrivacidad
        } catch (error) {
            
            const alerta = {
                msg: error,
                categoria: 'error'
            }
            return alerta
        }
    }

    const aceptarTerminos = async ( terminosId ) => {
        try {
            // siempre deberia venir un cliente            
            const resultado = await clienteAxios.post(`/terminos-y-condiciones/aceptar`,
            { terminosYCondicionesId: terminosId }
            );

            return !!resultado.data.terminosYCondiciones
        } catch (error) {
            
            const alerta = {
                msg: error,
                categoria: 'error'
            }
            return alerta
        }
    }

    const nuevosTerminos = async( file ) => {
        dispatch({
            type: PROGRESS,
            payload: 0
        });
        try {
            const response = clienteAxios.post('/terminos-y-condiciones', file, {
                onUploadProgress: (ProgressEvent) => {
                    let progress = Math.round(
                    ProgressEvent.loaded / ProgressEvent.total * 100) ;
                    dispatch({
                        type: PROGRESS,
                        payload: progress
                    });
                }
            })
            return response
        } catch (error) {
            
            const alerta = {
                msg: error,
                categoria: 'error'
            }
            return alerta
        }
    }
    
    const nuevasPoliticas = async( file ) => {
        dispatch({
            type: PROGRESS,
            payload: 0
        });
        try {
            const response = clienteAxios.post('/politicas-de-privacidad', file, {
                onUploadProgress: (ProgressEvent) => {
                    let progress = Math.round(
                    ProgressEvent.loaded / ProgressEvent.total * 100) ;
                    dispatch({
                        type: PROGRESS,
                        payload: progress
                    });
                }
            })
            return response
        } catch (error) {
            
            const alerta = {
                msg: error,
                categoria: 'error'
            }
            return alerta
        }
    }

    const resetProgress = async() => {
        
        dispatch({
            type: PROGRESS,
            payload: 0
        });
        return
    }

    return (
        <legalesContext.Provider
            value={{
                politicasDePrivacidad: state.politicasDePrivacidad,
                terminosYCondiciones: state.terminosYCondiciones,
                terminosAceptados: state.terminosAceptados,
                politicasAceptadas: state.politicasAceptadas,
                progress: state.progress,
                aceptarPoliticas,
                aceptarTerminos,
                obtenerTerminosYCondiciones,
                obtenerTerminosYCondicionesHistorico,
                obtenerPoliticasDePrivacidadHistorico,
                obtenerPoliticasAceptadas,
                obtenerPoliticasDePrivacidad,
                obtenerTerminosAceptados,
                nuevosTerminos,
                nuevasPoliticas,
                resetProgress,                
            }}
        >
            {props.children}
        </legalesContext.Provider>
    )
}

export default LegalesState;